import { isDarkColor } from '@elfsight/lib-utils';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../constants/meta';

export const FREE_LINK_HEIGHT = 21;

export const StyledFreeLink = () => {
  const { layout, messageColor, ...settings } = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  const isInline = layout === 'inline';
  const isBottomLayout = layout === 'floating-bottom';
  const isDarkMessageColor = isDarkColor(messageColor);

  const color = isDarkMessageColor ? '#111' : '#fff';
  const backgroundAlphaValue = isDarkMessageColor ? 5 : 10;

  return (
    <FreeLink
      {...freeLinkSettings}
      appAlias={meta.alias}
      appName={meta.name}
      mode={isInline ? 'button' : 'text'}
      textModeProps={{
        color,
        fontSize: 10
      }}
      iconHidden
      style={
        isInline
          ? {
              link: {
                marginTop: '20px'
              }
            }
          : {
              link: {
                position: 'absolute',
                top: isBottomLayout ? 'auto' : 0,
                bottom: isBottomLayout ? 0 : 'auto',
                height: `${FREE_LINK_HEIGHT}px`,
                zIndex: 999999999,
                width: '100%',
                maxWidth: '100%',
                lineHeight: 1.3,
                margin: 0,
                padding: '4px 0',
                backgroundColor: `rgb(from ${color} r g b / ${backgroundAlphaValue}%)`,
                backdropFilter: 'blur(40px)'
              }
            }
      }
    />
  );
};
